import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header} from 'semantic-ui-react'

import personalityBackground1 from 'img/personality-background.png';
import personalityBackground2 from 'img/personality-background2.png';
import Utils from 'utils/Utils.js';
import {colors, fontSizes, shadow, spacings} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    images: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0',
        marginBottom: '0',
        position: 'relative',
        height: '214px',
        width:'500px',
        overflow: 'hidden',

    },
    personalityBackground1: {
        position: 'absolute',
        top: ' 45px',
        left:  '0px',
        width: '500px',
    },
    personalityBackground2: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '500px',
    },
    persona: {
        position: 'absolute',
        bottom: '85px',
        left: '192px',
        height: '120px',
    },
    personaImages: {
        position: 'relative',
        height: '120px',
        width: '120px',
    },
    personaShadow: {
        position: 'absolute',
        bottom: '-5px',
        left: '50%',
        height: '10px',
        width: '50px',
        marginLeft: '-25px',
        backgroundColor: 'rgba(0,0,0,0.3)',
        borderRadius: '25px / 5px',
    },
    personaImage: {
        position: 'absolute',
        bottom: '0px',
        left: '0px',
        height: '120px',
        width: '120px',
        backgroundPosition:'50% 50%', 
        backgroundSize:'contain',
        backgroundRepeat: 'no-repeat',
    },
    heading:{
        color: colors.themeDarkerGrey,
        fontSize: fontSizes.h2,
        lineHeight: '1.5',
    },
    subheading: {
        color: colors.themeTeal,
        fontSize: fontSizes.h2,
        lineHeight: '1.5',
    },
    description: {
        color: '#fff',
        backgroundColor: '#5b7986',
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
        paddingBottom: spacings.large,
        borderBottomLeftRadius: spacings.small,
        borderBottomRightRadius: spacings.small,
        boxShadow: shadow,
    },
    topText: {
        minHeight: '200px',
    }
}

const SurveyPagePersonalityType = ({t, 
                         userProfile,
                         surveyPage, 
                         survey, 
                         onSubmit, 
                         onSkip, 
                         pageNum, 
                         numPages}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <form onSubmit={e => onSubmit(e)}>

                <div style={style.topText}>
                    <div style={style.heading}>{t('personality_recommendation_title', {firstName:userProfile.firstName})}</div>
                    <div style={style.subheading}>{surveyPage.title}</div>
                </div>

                <div style={style.images}>
                    <img alt='' style={style.personalityBackground1} src={personalityBackground1} />
                    <img alt='' style={style.personalityBackground2} src={personalityBackground2} />
                    {Boolean(surveyPage.asset && surveyPage.asset.url) && 
                        <div style={style.persona}>
                            <div style={style.personaImages}>
                                <div style={style.personaShadow} />
                                <div style={{...style.personaImage, backgroundImage:Utils.url(surveyPage.asset.url)}}/>
                            </div>
                        </div>
                    }
                </div>

                <div style={style.description}>
                    {surveyPage.description}
                    <br />
                    <br />
                    <br />
                    <Button style={style.tealButton} type="button" onClick={e => onSubmit(e)}>{t('Get Recommendations')}</Button>
                </div>

            </form>

            {/*<pre style={{textAlign: 'left'}}>{JSON.stringify(survey,null,2)}</pre>*/}
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPagePersonalityType);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPagePersonalityType.js